module.exports = __webpack_public_path__ + "static/image/sustainability/img-protection-1.ver2_0_2.png?45011a17";